<script setup>
defineProps({
  name: { type: String, required: true },
  filled: { type: Boolean, default: false },
});
</script>

<template>
  <span
    class="material-symbols-outlined leading-none"
    :style="{
      fontVariationSettings: `'FILL' ${filled ? 1 : 0}, 'wght' 400, 'GRAD' 0, 'opsz' 24`,
    }"
    aria-hidden="true"
  >
    {{ name }}
  </span>
</template>
